import PhysicalActivitySR from 'libs/shared/ui/src/lib/components/my-evolution/physical-activity/physical-activity'

export const PhysicalActivity = () => {
  return (
    <div className="mt-10">
      <PhysicalActivitySR />
    </div>
  )
}
